import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const BinaryScroll = ({ fromRight = true }) => {
  const textRef = useRef(null);

  useEffect(() => {
    let mm = gsap.matchMedia();
    const startX = fromRight ? 100 : -100;
    const endX = fromRight ? -100 : 100;

    mm.add("(min-width: 769px)", () => {
      return gsap.fromTo(
        textRef.current,
        { xPercent: startX },
        {
          xPercent: endX,
          ease: "none",
          scrollTrigger: {
            trigger: textRef.current,
            start: "top 100%",
            end: "bottom -20%",
            scrub: 3,
            invalidateOnRefresh: true,
          },
        }
      );
    });

    // mm.add("(max-width: 768px)", () => {
    //   return gsap.fromTo(
    //     textRef.current,
    //     { xPercent: startX },
    //     {
    //       xPercent: endX,
    //       ease: "none",
    //       scrollTrigger: {
    //         trigger: textRef.current,
    //         start: "top 200%",
    //         end: "bottom -100%",
    //         scrub: 3,
    //         invalidateOnRefresh: true,
    //       },
    //     }
    //   );
    // });

    return () => mm.revert(); // Ensures proper cleanup
  }, [fromRight]);

  return (
    <div className="binary-scroll-container">
      <div ref={textRef} className="binary-text">
        N 01001110 &nbsp;&nbsp;&nbsp;&nbsp; <span>I 01101001</span> &nbsp;&nbsp;&nbsp;&nbsp;
        H 01101000 &nbsp;&nbsp;&nbsp;&nbsp; <span>A 01100001</span> &nbsp;&nbsp;&nbsp;&nbsp;
        L 01101100
      </div>
    </div>
  );
};

export default BinaryScroll;